"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocalDays = exports.convertLocalDaysOfWeekToUTC = exports.nextUTCDay = exports.nextLocalDay = void 0;
function nextLocalDay(date, day) {
    date = new Date(date);
    let delta = day - date.getDay();
    if (delta <= 0)
        delta += 7;
    date.setDate(date.getDate() + delta);
    return date;
}
exports.nextLocalDay = nextLocalDay;
function nextUTCDay(date, day) {
    date = new Date(date);
    day = day % 7;
    let delta = day - date.getUTCDay();
    if (delta <= 0)
        delta += 7;
    date.setUTCDate(date.getUTCDate() + delta);
    return date;
}
exports.nextUTCDay = nextUTCDay;
function ruleAsNumber(x) {
    return (typeof x === 'string' ? parseInt(x) : x);
}
function convertLocalDaysOfWeekToUTC(daysOfWeek, parsedCron) {
    return daysOfWeek.map(dayNum => {
        const date = new Date();
        date.setUTCHours(ruleAsNumber(parsedCron.hours[0]), ruleAsNumber(parsedCron.minutes[0]));
        return nextLocalDay(date, dayNum - 1).getUTCDay() + 1;
    });
}
exports.convertLocalDaysOfWeekToUTC = convertLocalDaysOfWeekToUTC;
const DAYS_OF_WEEK = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
function getLocalDays(parsedCron) {
    return parsedCron.daysOfWeek.map(dow => {
        dow = ruleAsNumber(dow);
        if (isNaN(dow)) {
            dow = DAYS_OF_WEEK.findIndex(x => x === dow) + 1;
        }
        const date = nextUTCDay(Date.now(), dow - 1);
        date.setUTCHours(ruleAsNumber(parsedCron.hours[0]), ruleAsNumber(parsedCron.minutes[0]));
        return date.getDay() + 1;
    });
}
exports.getLocalDays = getLocalDays;
//# sourceMappingURL=local.js.map